export const isBooleanStr = (input: any): boolean => ['true', 'false'].includes(input);
